(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/youtube-video/assets/javascripts/youtube-video.js') >= 0) return;  svs.modules.push('/components/components/youtube-video/assets/javascripts/youtube-video.js');

'use strict';

const {
  useState
} = React;
const {
  ReactIcon: Icon
} = svs.ui;
const YoutubeVideo = _ref => {
  let {
    videoId,
    src,
    heightPercent,
    height,
    width,
    title,
    thumbnailUrl,
    fitWrapper
  } = _ref;
  const [renderIframe, setRenderIframe] = useState(false);
  const renderYoutubePlayer = () => {
    setRenderIframe(true);
  };
  return React.createElement("div", {
    className: "js-youtube-video-container youtube-video-container react-yt-video ".concat(fitWrapper ? 'youtube-video-container-fit' : ''),
    "data-video-id": videoId,
    itemProp: "video",
    itemScope: true,
    itemType: "http://schema.org/VideoObject",
    style: heightPercent ? {
      paddingBottom: "".concat(heightPercent, "%")
    } : null
  }, renderIframe && React.createElement("iframe", {
    allow: "accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture",
    allowFullScreen: true,
    alt: title,
    className: "js-youtube-video-iframe js-youtube-video-".concat(videoId, " youtube-video-iframe"),
    height: height,
    src: "".concat(src, "&autoplay=1"),
    title: title,
    width: width
  }), !renderIframe && React.createElement("div", {
    className: "youtube-video-player js-youtube-video-player",
    onClick: renderYoutubePlayer
  }, React.createElement("picture", {
    className: "youtube-video-thumbnail-wrapper"
  }, React.createElement("source", {
    media: "(min-width: 1280px)",
    srcSet: "".concat(thumbnailUrl, "/maxresdefault.jpg")
  }), React.createElement("source", {
    media: "(min-width: 640px)",
    srcSet: "".concat(thumbnailUrl, "/sddefault.jpg")
  }), React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: "".concat(thumbnailUrl, "/hqdefault.jpg")
  }), React.createElement("source", {
    media: "(min-width: 320px)",
    srcSet: "".concat(thumbnailUrl, "/mqdefault.jpg")
  }), React.createElement("img", {
    className: "youtube-video-thumbnail",
    height: height,
    src: "".concat(thumbnailUrl, "/default.jpg"),
    title: title,
    width: width
  })), React.createElement("div", {
    className: "youtube-video-icon"
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "play",
    size: "800"
  }))));
};
svs.components.youtube_video.YoutubeVideo = YoutubeVideo;

 })(window);